import { Component, computed, input, Input, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ContractorAppEntityApplicationRead,
  ContractorAppEntityContractorWrite
} from '../../../../../../../openapi';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ContractorsPreviewComponent } from '../contractors-preview/contractors-preview.component';
import { ContractorTag } from '../../contractor-data-section.component';

@Component({
  selector: 'app-contractor-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    ContractorsPreviewComponent
  ],
  templateUrl: './contractor-data-preview.component.html'
})
export class ContractorDataPreviewComponent {
  @Input()
  public expanded: boolean = true;

  @Input()
  public tag: ContractorTag | undefined;

  public application = input<ApplicationAppEntityApplicationRead | null>(null);

  public contractors: Signal<ContractorAppEntityContractorWrite[]> = computed(() => {
    return (this.tag ? this.application()?.contractors?.filter(v => v.tag === this.tag) : this.application()?.contractors)?.map((contractor: ContractorAppEntityApplicationRead) => ({
        entityType: contractor.entityType?.id || '',
        firstName: contractor?.firstName || '',
        lastName: contractor?.lastName || '',
        name: contractor?.name || '',
        nip: contractor?.nip || '',
        city: contractor.city,
        email: contractor.email,
        apartmentNumber: contractor.apartmentNumber,
        houseNumber: contractor.houseNumber,
        phoneNumber: contractor.phoneNumber,
        phoneNumber2: contractor.phoneNumber2,
        postalCode: contractor.postalCode,
        postOffice: contractor.postOffice,
        street: contractor.street
      })
    ) || [];
  });
}
